export default __webpack_public_path__ + "static/media/대구.47e032b5.png";